import axios from 'axios';
import { NETLIFY_FUNCTIONS_PATH } from '../constants';

// Validates phone number and email using PossibleNow API
export async function validateWithPossibleNow(phone, email) {
    const apiEndpoint = `${NETLIFY_FUNCTIONS_PATH}possible-now-validator`;

    const response = await axios.post(apiEndpoint, {
        phone,
        email,
    });

    return response.data;
}
